import LocationPage, { LocationData } from './LocationPage';

const westPalmBeachData: LocationData = {
  city: 'West Palm Beach',
  state: 'Florida',
  stateAbbr: 'FL',
  slug: 'west-palm-beach',
  heroTitle: 'Hire smarter in West Palm Beach',
  heroSubtitle: 'West Palm Beach is booming. Keep up with demand by automating your hiring with instant applicant emails, Calendly scheduling, and a powerful applicant dashboard.',
  metaDescription: 'iHireFast helps West Palm Beach businesses hire faster with automated emails, Calendly scheduling, custom forms, and applicant tracking. Free to start.',
  industries: [
    { name: 'Finance & Insurance', icon: '🏦', description: 'Palm Beach County is a financial hub with major firms, wealth management companies, and insurance agencies all competing for talent.' },
    { name: 'Healthcare', icon: '🏥', description: 'JFK Medical Center, Good Samaritan, and dozens of clinics drive constant demand for healthcare professionals.' },
    { name: 'Hospitality & Resorts', icon: '🌴', description: 'The Breakers, Palm Beach resorts, and Clematis Street restaurants need hospitality workers year-round.' },
    { name: 'Agriculture & Equestrian', icon: '🐴', description: 'Wellington\'s equestrian industry and Palm Beach County\'s agriculture sector create unique hiring needs.' },
    { name: 'Retail & Service', icon: '🛍️', description: 'CityPlace, Gardens Mall, and the growing downtown district drive retail and service sector hiring.' },
    { name: 'Government & Education', icon: '🏛️', description: 'Palm Beach County government and school district are top employers with steady recruitment cycles.' },
  ],
  stats: [
    { label: 'Avg. Time to Hire', value: '3.5 days' },
    { label: 'Response Rate', value: '91%' },
    { label: 'PBC Businesses', value: '120+' },
    { label: 'Applicants Processed', value: '2K+' },
  ],
  neighborhoods: [
    'Downtown West Palm Beach', 'Clematis Street', 'CityPlace', 'Northwood Village',
    'Palm Beach Gardens', 'Jupiter', 'Royal Palm Beach', 'Wellington',
    'Lake Worth Beach', 'Boynton Beach', 'Delray Beach', 'Boca Raton',
    'Palm Beach Island', 'Riviera Beach', 'Greenacres', 'Palm Springs',
  ],
  testimonial: {
    quote: 'We were losing great candidates because we couldn\'t respond fast enough. With iHireFast, every applicant gets an email within seconds and can book an interview on their own. It\'s been a game-changer for our Palm Beach Gardens locations.',
    name: 'Karen Mitchell',
    role: 'Talent Acquisition Lead',
    company: 'PBC Health Partners',
  },
  localInsight: 'Palm Beach County is experiencing rapid population growth as remote workers and businesses relocate from the northeast. This influx has intensified competition for local talent across all sectors. Businesses that automate their hiring process gain a significant edge.',
  jobMarketDescription: 'Palm Beach County has over 700,000 employed residents and a GDP exceeding $100 billion. West Palm Beach is undergoing a transformation with new corporate relocations, luxury development, and a thriving downtown scene. The seasonal population surge also creates unique hiring challenges for hospitality and retail.',
};

export default function WestPalmBeachPage() {
  return <LocationPage data={westPalmBeachData} />;
}
